module.exports = __webpack_public_path__ + "img/zyjy_01.3b2865fa.png";